export const APIS = {
  Auth: "/common/auth/admin-login",
  UserInfo: "/common/auth/user-info",
  AdminInfo: "/common/auth/admin-login",

  dashboard: {
    dashboard: "/admin/dashboard",
  },
  Commons: {
    AllCountry: "/common/master/all-countries",
    AllRoles: "/common/master/all-roles",
    AllStates: "/common/master/all-states",
    AllCities: "/common/master/all-cities",
    AllPincodes: "/common/master/all-pincodes",
    AllGender: "/common/master/all-genders",
    AllVehicleCategory: "/common/master/all-vehicle-category",
    AllVehicleCategorywithouttype:
      "/common/master/all-vehicle-category-without-type",
    AllVehicleType: "/common/master/all-vehicle-type",
  },

  Masters: {
    Permission: "/common/master/all-permissions",
    Country: "/admin/masters/country",
    State: "/admin/masters/state",
    City: "/admin/masters/city",
    Pincode: "/admin/masters/pincode",
    Vehicle_Category: "/admin/masters/vehicle-category",
    Banner: "/admin/masters/banner",
    About_Us: "/admin/masters/about-us",
    Key_Feature: "/admin/masters/key-features",
    Why_Choose_Us: "/admin/masters/why-choose-us",
    Term_Condition: "/admin/masters/terms-condition",
    Save_Location: "/admin/masters/save-location",
    Good_Type: "/admin/masters/good-type",
    Faq: "/admin/masters/faq",
    Privacy_Policy: "/admin/masters/privacy-policy",
    driver_privacy_policy: "/admin/masters/driver-privacy-policy",
    customer_terms_and_condition: "/admin/masters/customer-terms-and-condition",
    shipping_ride_policy: "/admin/masters/shipping-ride-policy",
    cancellation_policy: "/admin/masters/cancellation-policy",
    refund_policy: "/admin/masters/refund-policy",
    driver_terms_and_condition: "/admin/masters/driver-terms-and-condition",
    Training_Video: "/admin/masters/training-video",
    Driver_Banner: "/admin/masters/driver-banners",
    Amenity: "/admin/masters/amenity",
    AboutMe: "/admin/masters/about-me",
    Model: "/admin/masters/model",
    Vehicle: "/admin/masters/vehicle",
    Eco_Friendly: "/admin/masters/eco-friendly",
    Coupon: "/admin/masters/coupon",
    Coupon_History: "/admin/masters/coupon-history",
    booking_tnc: "/admin/masters/customer-booking-tnc",
    bookingCancelReason: "/admin/masters/booking-cancel-reason",
    refund_policy: "/admin/masters/refund-policy",
    VehicleType: "/admin/masters/vehicle-type",
  },

  Recharge_Management: {
    Recharge: "/admin/recharge-management/recharge",
    UserRecharge: "/admin/recharge-management/user-recharge",
  },
  Gift_Management: {
    Gift: "/admin/gift-management/gift",
    UserGift: "/admin/gift-management/user-gift",
  },

  Broadcast: {
    Broadcast: "/admin/broadcast/broadcast",
  },

  Document: {
    Document: "/admin/document/document",
  },

  Customization: {
    App_Setup: "/admin/customization/app-setup",
  },

  HeatMap: {
    heat_map: "/admin/heat-map",
    heat_map_cab: "/admin/heat-map-cab",
  },

  Form: {
    Contact: "/admin/contact",
    Enquiry: "/admin/enquiry",
  },

  Customer_Management: {
    Driver: "/admin/driver",
    Customer: "/admin/customer",
  },

  User_Management: {
    User: "/admin/user",
  },

  Role_Management: {
    Role: "/admin/role-management/role",
  },

  SOSRequest: {
    SOSRequest: "/admin/sos-request",
  },

  Booking: {
    Booking: "/admin/booking",
  },

  CabBooking: {
    Booking: "/admin/cab-booking",
  },

  ShareBooking: {
    Booking: "/admin/share-booking",
  },

  driver_Wallet: {
    withdraw_request: "/admin/wallet/wallet-withdraw-request",
    wallet_history: "/admin/wallet/wallet-history",
    wallet_payment: "/admin/wallet/wallet-payment",
    fund_add_request: "/admin/wallet/wallet-fund-add-request",
  },

  customer_wallet: {
    withdraw_request: "/admin/customer-wallet/wallet-withdraw-request",
    wallet_history: "/admin/customer-wallet/wallet-history",
    fund_add_request: "/admin/customer-wallet/wallet-fund-add-request",
  },
};
